import { Action, ActionReducer } from '@ngrx/store';
import { ParameterType } from '../../../_generated';
import { DataTypeAction, DataTypeActionType } from '../../actionstypes/data-type/data-type.actiontype';

const initialState: ParameterType = ParameterType.air;

const dataTypeReducer = (state = initialState, action: DataTypeActionType): ParameterType => {
  switch (action.type) {
    case DataTypeAction.Set:
      return action.payload;

    case DataTypeAction.Reset:
      return ParameterType.air;

    default:
      return state;
  }
};

export default dataTypeReducer as ActionReducer<ParameterType, Action<string>>;
